import { useTranslation } from 'react-i18next';
import type { SaaSProductTranslation } from '../../types/saas/products';

export const useNextcloudSaaS = () => {
  const { t } = useTranslation('saas-nextcloud');

  const getTranslation = (): SaaSProductTranslation => ({
    title: t('title'),
    description: t('description'),
    tiers: {
      starter: {
        title: t('tiers.starter.title'),
        subtitle: t('tiers.starter.subtitle'),
        features: t('tiers.starter.features', { returnObjects: true })
      },
      business: {
        title: t('tiers.business.title'),
        subtitle: t('tiers.business.subtitle'),
        features: t('tiers.business.features', { returnObjects: true })
      },
      enterprise: {
        title: t('tiers.enterprise.title'),
        subtitle: t('tiers.enterprise.subtitle'),
        features: t('tiers.enterprise.features', { returnObjects: true })
      }
    }
  });

  return { getTranslation };
};